const textAnimationBlog = () => {
	const sections = document.querySelectorAll(".text-animation-blog");

	if (!sections.length) return;

	sections.forEach((section) => {
		const nextButton = section.querySelector(".load-more-posts");
		const prevButton = section.querySelector(".load-prev-posts");
		const postsContainer = section.querySelector(".box-posts");
		const imageContainer = section.querySelector(".box-featured-image");

		if (!nextButton || !prevButton || !postsContainer || !imageContainer) return;

		let currentPage = parseInt(nextButton.dataset.page, 10) || 1;
		let maxPages = parseInt(nextButton.dataset.maxPages, 10) || 1;
		let isLoading = false;
		const categories = nextButton.dataset.categories;
		const language = section.dataset.language || "";
		const transitionDuration = 260;

		const updateControls = () => {
			const pagination = prevButton.closest(".box-pagination");

			prevButton.closest(".box-button").style.display =
				currentPage > 1 ? "" : "none";
			nextButton.closest(".box-button").style.display =
				currentPage < maxPages ? "" : "none";
			pagination?.classList.toggle("has-previous", currentPage > 1);

			prevButton.dataset.page = currentPage;
			nextButton.dataset.page = currentPage;
			prevButton.dataset.categories = categories;
			nextButton.dataset.categories = categories;
		};
		const setLoadingState = (loading) => {
			nextButton.classList.toggle("is-loading", loading);
			prevButton.classList.toggle("is-loading", loading);

			postsContainer.classList.toggle("is-loading", loading);

			nextButton.setAttribute("aria-disabled", loading);
			prevButton.setAttribute("aria-disabled", loading);
		};

		const setFirstActiveItem = () => {
			const posts = postsContainer.querySelectorAll(".content-posts");
			const images = imageContainer.querySelectorAll(".featured-image");
		};
		const bindHoverEvents = () => {
			const posts = postsContainer.querySelectorAll(".content-posts");
			const images = imageContainer.querySelectorAll(".featured-image");

			const activate = (index) => {
				posts.forEach((post) => post.classList.remove("active"));
				images.forEach((image) => image.classList.remove("active"));

				posts[index]?.classList.add("active");
				images[index]?.classList.add("active");
			};

			posts.forEach((post, index) => {
				post.addEventListener("mouseenter", () => {
					activate(index);
				});

				post.addEventListener("mouseleave", () => {
					post.classList.remove("active");
					images[index]?.classList.remove("active");
				});
			});
		};

		const refreshUI = () => {
			setFirstActiveItem();

			updateControls();
		};
		const renderPosts = (posts) => {
			const cards = postsContainer.querySelectorAll(".content-posts");

			cards.forEach((card, index) => {
				const post = posts[index];
				const wrapper = card.closest(".box-post");

				wrapper.hidden = !post;

				if (!post) {
					card.classList.remove("active");
					return;
				}

				card.querySelector(".publication-date").innerHTML = post.date;
				card.querySelector(".title").innerHTML = post.title;
				card.querySelector(".category").innerHTML = post.category;
			});
		};
		const renderImages = (posts) => {
			const figures = imageContainer.querySelectorAll(".featured-image");

			figures.forEach((figure, index) => {
				const post = posts[index];

				figure.hidden = !post;
				figure.classList.remove("active");

				if (!post) return;

				const img = figure.querySelector("img");

				if (!img) return;

				img.src = post.image || "";
				img.alt = post.alt || "";
			});
		};
		const animatePostsOut = (direction) => {
			const cards = postsContainer.querySelectorAll(".content-posts");

			cards.forEach((card, index) => {
				card.style.transition =
					"transform .55s cubic-bezier(.22,.61,.36,1), opacity .55s ease-out";

				card.style.transitionDelay = `${index * 40}ms`;

				card.style.opacity = ".18";

				card.style.transform =
					direction === "next" ? "translateY(-25px)" : "translateY(25px)";
			});
		};
		const animatePostsIn = () => {
			const cards = postsContainer.querySelectorAll(".content-posts");

			cards.forEach((card, index) => {
				card.style.transition =
					"transform .7s cubic-bezier(.22,.61,.36,1), opacity .7s ease-out";

				card.style.transitionDelay = `${index * 50}ms`;

				card.style.opacity = "1";

				card.style.transform = "translateY(0)";
			});
		};
		const renderPage = (data, page, direction) => {
			renderPosts(data.posts);

			renderImages(data.posts);

			const cards = postsContainer.querySelectorAll(".content-posts");

			cards.forEach((card) => {
				card.style.opacity = ".15";

				card.style.transform =
					direction === "next" ? "translateY(25px)" : "translateY(-25px)";
			});

			requestAnimationFrame(() => {
				animatePostsIn();
			});

			currentPage = page;

			maxPages = data.max_pages;

			refreshUI();

			postsContainer.classList.remove("is-leaving-up", "is-leaving-down");

			postsContainer.classList.add(
				direction === "next" ? "is-entering-from-bottom" : "is-entering-from-top",
			);

			window.setTimeout(() => {
				postsContainer.classList.remove(
					"is-entering-from-bottom",
					"is-entering-from-top",
				);

				setLoadingState(false);

				isLoading = false;
			}, transitionDuration);
		};

		const animateOut = (direction) => {
			postsContainer.classList.add(
				direction === "next" ? "is-leaving-up" : "is-leaving-down",
			);
		};
		const animateIn = (direction) => {
			postsContainer.classList.remove("is-leaving-up", "is-leaving-down");

			postsContainer.classList.add(
				direction === "next" ? "is-entering-from-bottom" : "is-entering-from-top",
			);
		};

		const loadPage = (page, direction = "next") => {
			if (isLoading) return;

			isLoading = true;
			setLoadingState(true);

			const formData = new FormData();

			formData.append("action", "load_more_blog_posts");
			formData.append("page", page);
			formData.append("categories", categories);
			formData.append("lang", language);
			const currentHeight = postsContainer.offsetHeight;
			postsContainer.style.minHeight = `${currentHeight}px`;
			animatePostsOut(direction);

			const controller = new AbortController();

			const requestTimeout = window.setTimeout(() => {
				controller.abort();
			}, 30000);

			fetch(ajax_object.ajax_url, {
				method: "POST",
				body: formData,
				signal: controller.signal,
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(`Request failed: ${response.status}`);
					}

					return response.json();
				})
				.then((data) => {
					if (
						!data ||
						!Array.isArray(data.posts) ||
						!Number.isFinite(Number(data.max_pages)) ||
						data.posts.length === 0
					) {
						throw new Error("Invalid or empty blog response.");
					}

					renderPage(data, page, direction);
				})
				.catch((error) => {
					animatePostsIn();

					postsContainer.classList.remove(
						"is-leaving-up",
						"is-leaving-down",
						"is-entering-from-bottom",
						"is-entering-from-top",
					);

					setLoadingState(false);
					isLoading = false;

					console.error("Blog pagination failed:", error);
				})
				.finally(() => {
					window.clearTimeout(requestTimeout);
				});
		};

		nextButton.addEventListener("click", () => {
			if (currentPage >= maxPages) return;

			loadPage(currentPage + 1, "next");
		});

		prevButton.addEventListener("click", () => {
			if (currentPage <= 1) return;

			loadPage(currentPage - 1, "prev");
		});

		setFirstActiveItem();
		updateControls();
		bindHoverEvents();

		textAnimationBlogSlider();
	});
};

const textAnimationBlogSlider = () => {
	const sections = document.querySelectorAll(".text-animation-blog");

	sections.forEach((section) => {
		const imageBox = section.querySelector(".box-featured-image");

		if (!imageBox) return;

		const scale = parseFloat(
			getComputedStyle(section).getPropertyValue("--text-scale"),
		);

		const fontSize = imageBox.offsetHeight * scale;

		section.querySelectorAll(".box-text span").forEach((span) => {
			span.style.fontSize = `${fontSize}px`;
		});
	});
};

export { textAnimationBlog, textAnimationBlogSlider };
